export default "/images/87414c8481316467963cc2a77f08b371.avif";